import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { STOCK_LOGO_PLACEHOLDER } from '@toro/common/shared/resources/consts';

@Component({
    selector: 'card-header',
    templateUrl: './card-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./card-header.component.scss'],
})
export class CardHeaderComponent {
    @Input() public stockDetails: any;
    @Input() public symbol: string;
    @Input() public symbolLogo: string;
    @Input() public name: string;
    @Input() public side: string;
    @Input() public dayTrade: boolean = false;
    @Input() public expired: boolean = false;
    @Input() public pending: boolean = false;
    @Input() public simulation: boolean = false;
    @Input() public closing: boolean;
    @Input() public barrierReached: boolean;

    get label(): string {
        if (this.pending) return 'Pendente';
        else if (this.expired) return 'Sem Negociação';
        else if (this.dayTrade) return 'Encerra hoje';
        else if (this.simulation) return 'Simulação';
        else if (this.barrierReached) return 'Barreira atingida';
        else return '';
    }

    public noLogoHandler(event) {
        this.symbolLogo = STOCK_LOGO_PLACEHOLDER;
    }
}
